import { render, staticRenderFns } from "./SetupPushAbnormal.vue?vue&type=template&id=f3e6b758&"
import script from "./SetupPushAbnormal.vue?vue&type=script&lang=js&"
export * from "./SetupPushAbnormal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports